export function keyedDecorator(factory) {
    function Decorator(target) {
        return factory()(target);
    }
    // tslint:disable-next-line:prefer-object-spread
    return Object.assign(Decorator, {
        key(key) {
            return factory(key);
        },
    });
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoia2V5ZWREZWNvcmF0b3IuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJrZXllZERlY29yYXRvci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFQSxNQUFNLFVBQVUsY0FBYyxDQUFJLE9BQXlDO0lBQ3ZFLFNBQVMsU0FBUyxDQUE2QixNQUFpQjtRQUM1RCxPQUFPLE9BQU8sRUFBRSxDQUFDLE1BQU0sQ0FBQyxDQUFDO0lBQzdCLENBQUM7SUFFRCxnREFBZ0Q7SUFDaEQsT0FBTyxNQUFNLENBQUMsTUFBTSxDQUFDLFNBQVMsRUFBRTtRQUM1QixHQUFHLENBQUMsR0FBVztZQUNYLE9BQU8sT0FBTyxDQUFDLEdBQUcsQ0FBQyxDQUFDO1FBQ3hCLENBQUM7S0FDSixDQUFDLENBQUM7QUFDUCxDQUFDIn0=